import { Injectable } from '@angular/core';

import { IAppConfig } from '../interfaces';
import { AppConfig } from '../configs/app-config';

export interface IAppInfo {
  name: string;
  version: string;
  logo: string;
}

export class ModuleList {
  private _AvailableModules: string[];
  private _DisabledModules: string[];

  constructor(availableModules: string[], disabledModules: string[]) {
    this._AvailableModules = availableModules;
    this._DisabledModules = disabledModules;
  }

  public isAvailable(name: string): boolean {
    return (this._AvailableModules.indexOf(name) > -1) || (!this.isDisabled(name));
  }

  public isDisabled(name: string): boolean {
    return this._DisabledModules.indexOf(name) > -1;
  }

  public get availableModules(): string[] {
    return this._AvailableModules;
  }

  public get disabledModules(): string[] {
    return this._DisabledModules;
  }
}

@Injectable()
export class AppConfigService {
  private logopath = "/app/resources/images/logos/logoname.png";
  private appConfig: IAppConfig;

  constructor() {
    this.appConfig = AppConfig;
  }

  public get appInfo(): IAppInfo {
    return <IAppInfo> {
      logo: this.appConfig.AppLogo != null ? this.logopath.replace("logoname", this.appConfig.AppLogo.toLowerCase()) : null,
      name: this.appConfig.AppName != null ? this.appConfig.AppName : 'Divardy Web-App',
      version: 'v. ' + (this.appConfig.AppVersion != null ? this.appConfig.AppVersion : '1.0.0')
    };
  }

  public get apiLogin(): IAppConfig{
    return this.appConfig;
  }

  public get apiHost(): string {
    let host = this.appConfig.ApiHost;
    return host != null ? host : '';
  }

  public get apiUrl(): string {
    let url = this.appConfig.ApiUrl;
    return url != null ? url : '';
  }

  public get baseUrl(): string {
    return this.apiHost + this.apiUrl;
  }

  public get logLevel(): string {
    return this.appConfig.LogLevel;
  }

  public get languages(): string[] {
    if (this.appConfig.Languages == null) {
      return [];
    }
    return this.appConfig.Languages;
  }

  public get defaultLanguage(): string {
    var defLang = this.appConfig.DefaultLanguage;
    if (defLang == null || defLang === '' || this.languages.indexOf(defLang) === -1) {
      defLang = 'nl';
    }

    return defLang;
  }

  public get modules(): ModuleList {
    return new ModuleList(this.appConfig.AvailableModules, this.appConfig.DisabledModules);
  }
}